import React from 'react';
import {FilterTags} from '../types/filterTags';

type DownloadsFilterProps = {
    filterTags : FilterTags[]
    selectTag : (tagId : string) => void
    selectedTag : string
    showOptions : boolean
    setShowOptions : (showOptions : boolean) => void,
    singleTag : string
}

function DownloadsFilterTags({filterTags, selectTag, selectedTag, showOptions, setShowOptions, singleTag} : DownloadsFilterProps) {
    return (
        <div className='downloadsOverview__filter--tags'>
            {filterTags.map(
                tag => <a href={`?tag=${tag.identifier}`}
                          className={`downloadsOverview__filter--tags-item ${selectedTag === tag.identifier || selectedTag === tag.slug? 'active' : ''}`}
                          key={tag.identifier}
                          onClick={(event) => {
                              // prevent site reload
                              event.preventDefault();

                              // set the url query string, for easier copying
                              const url = new URL(window.location.toString());
                              url.searchParams.set('tag', tag.slug);
                              window.history.pushState(null, '', url.toString());

                              selectedTag === tag.slug ? selectTag(singleTag) : selectTag(tag.slug);
                              showOptions ? setShowOptions(false) : setShowOptions(tag.displayOptions);
                          }}
                >
                    {tag.name}
                </a>)}
        </div>
    );
}

export default DownloadsFilterTags;
